export const teamInfo = [
    {
        name: 'Brian Sneed',
        position: {en: 'CEO and Founder', es: 'CEO y Fundador'},
        link: 'https://www.linkedin.com/in/brian-sneed/'
    },
    {
        name: 'Cedric Borreguín',
        position: {en: 'Head of Software Engineering', es: 'Head of Software Engineering'},
        link: 'https://www.linkedin.com/in/cedric-borreguin/'
    },
    {
        name: 'Irving Ché',
        position: {en: 'Full Stack Developer', es: 'Desarrollador Full Stack'},
        link: 'https://www.linkedin.com/in/irving-r-ch%C3%A9-587377184/'
    },
    {
        name: 'David Dorbecker',
        position: {en: 'Full Stack Developer', es: 'Desarrollador Full Stack'},
        link: 'https://www.linkedin.com/'
    },
    {
        name: 'Guillermo Hernández',
        position: {en: 'UI/UX Designer', es: 'Diseñador UI/UX'},
        link: 'https://www.linkedin.com/'
    }
];